export default __webpack_public_path__ + "locales/es/ChangeUserTypeDialog.json?hash=6848caf3c49fad277b51472c5748cdee";